import BaseModelInstance from './base.model'
import { UserAccomplishment as ModelDefinition } from './model-definitions'
import { now } from './helpers'

class UserAccomplishment extends BaseModelInstance {
  afterSet = (key, value) => {}

  constructor(attribs) {
    super(ModelDefinition, attribs)
  }

  isRecognized = () => !!this.get('recognized_at')

  recognize = async opts => {
    const recognized_by = (opts || {})?.recognized_by
    if (!this.get('recognized_by') && parseInt(recognized_by, 10))
      this.set('recognized_by', parseInt(recognized_by, 10))

    if (!this.get('recognized_at')) this.set('recognized_at', now())

    try {
      await this.save()
      return true
    } catch (ex) {
      console.log(`${ex}`)
      return false
    }
  }
}

export default UserAccomplishment
